import styled from "styled-components";
import { getBackgroundColor } from "../../../../../ui/_themes/helpers";
import {
  bottomGradient,
  topGradient
} from "../../../../../ui/_utils/styleUtils";

export const SettingsContent = styled.div`
  flex: 1 1 auto;
  background: ${getBackgroundColor(
    "settingsWindowContent",
    "settingsWindow.content"
  )};
  position: relative;

  ${topGradient};
  ${bottomGradient};
`;
